import { Tooltip } from '@mui/material';
import './RequiredIcon.css';
import { t } from 'i18next';

const RequiredIcon = () => {
  return (
    <Tooltip
      title={<>{t('requiredField')}</>}
      placement="bottom"
    >
      <div className="RequiredIcon">*</div>
    </Tooltip>
  );
};

export default RequiredIcon;
